let PATH_API
let NEW_PATH
if (process.env.NODE_ENV == 'development') {
  NEW_PATH = 'http://192.168.1.222/corp'
  // NEW_PATH = 'https://corp.impr-inc.com/api'
  
  // NEW_PATH = 'http://yujie.local.com/corp'
  // NEW_PATH = 'https://corp.impr-inc.com/api_test'
  
} else if (process.env.NODE_ENV == 'production') {
  NEW_PATH = 'https://corp.impr-inc.com/api'
  // NEW_PATH = 'https://corp.impr-inc.com/api_test'
}

let api = {
  PATH_API: PATH_API,
  user: {
    loginByMail: NEW_PATH + '/loginByMail'
  },
  tool: {
    // Team
    getUserList:  NEW_PATH + '/getUserList',                    //  获取员工列表
    getUserInfo: NEW_PATH + '/getUserInfo',                     //  获取员工信息
    updateUserIntro: NEW_PATH + "/updateUserIntro",             //  修改自我介绍
    getAllGroup: NEW_PATH + "/getAllGroup",                     //  获取所有组信息
    getAllGroupNew: NEW_PATH + "/getAllGroupNew",               //  获取所有分组信息(新)
    updateOkr: NEW_PATH + "/updateOkr",                         //  更新OKR链接

    // Snippets
    getWorkRecord: NEW_PATH + "/getWorkRecord",                 //  获取个人工作记录
    getGroupRecord: NEW_PATH + "/getGroupRecord",               //  获取组工作记录
    dealWorkRecord: NEW_PATH + "/dealWorkRecord",               //  新添/修改工作记录
    deleteWorkRecord: NEW_PATH + "/deleteWorkRecord",           //  删除个人工作记录
    sendEmailByGroup: NEW_PATH + "/sendEmailByGroup",           //  发送工作记录邮件

    // WT3T
    getWt3tList: NEW_PATH + "/getWt3tList",                             //  获取WT3T列表
    addWt3t: NEW_PATH + "/addWt3t",                             //  新增WT3T
    updateWt3t: NEW_PATH + "/updateWt3t",                       //  修改WT3T
    deleteWt3t: NEW_PATH + "/deleteWt3t",                       //  删除WT3T

    // Snippets2
    dealDailyReport: NEW_PATH + '/dealDailyReport',             //  添加/修改工作报告
    getDailyReport: NEW_PATH + '/getDailyReport',               //  获取个人工作报告
    getGroupDailyReport: NEW_PATH + '/getGroupDailyReport',     //  获取组工作报告

    // Claim
    getInvoiceType: NEW_PATH + "/getInvoiceType",               //  获取发票类型
    getRbCategory: NEW_PATH + "/getRbCategory",                 //  获取报销类型
    addRbNum: NEW_PATH + "/addRbNum",                           //  新增报销单
    dealRbDetails: NEW_PATH + "/dealRbDetails",                 //  新增/修改报销详情
    getRbDetails: NEW_PATH + "/getRbDetails",                   //  获取报销单详情
    deleteRb:NEW_PATH + "/deleteRb",                            //  删除报销单
    getRbListByEe:NEW_PATH + "/getRbListByEe",                  //  获取报销单列表
    
    // Workday
    getLeaveType: NEW_PATH + "/getLeaveType",                   //  假期分类
    getBalanceByEe: NEW_PATH + "/getBalanceByEe",               //  获取当前员工假期详情
    addLeaveDetail: NEW_PATH + "/addLeaveDetail",               //  请假详情
    getLeaveHistory: NEW_PATH + "/getLeaveHistory",             //  获取请假历史
    getLeaveHistoryOut: NEW_PATH + "/getOutHistory",             //  获取请假历史
    getAllBalance: NEW_PATH + "/getAllBalance",                 //  获取团队假期信息
    cancelLeave: NEW_PATH + "/cancelLeave",                     //  取消请假
    getOutCategory: NEW_PATH + "/getOutCategory",               //  外出请假分类
    outDetail: NEW_PATH + "/outDetail",                         //  外出请假
    cancleOut: NEW_PATH + "/cancleOut",                         //  取消外出请假
    
    // Admin
    getEeId: NEW_PATH +"/getAddEeid",                           //  获取新员工id
    getJobTitle: NEW_PATH +"/getJobTitle",                      //  获取职位类型
    addEmployee: NEW_PATH +"/addEmployee",                      //  添加新员工
    getAllEeInfo: NEW_PATH +"/getAllEeInfo",                    //  获取所有员工信息
    editEmployee: NEW_PATH + "/editEmployee",                   //  修改员工信息
    getAllRbList: NEW_PATH + "/getAllRbList",                   //  获取所有已提交发票
    updateRbStatus: NEW_PATH + "/updateRbStatus",               //  修改报销单状态
    getManageList: NEW_PATH + "/getManageList",
    getServerStatus: NEW_PATH + "/serverStatus",                //  服务器状态
    getAttendanceRecord: NEW_PATH + "/getAttendanceRecord",
    getAttendanceSummary: NEW_PATH + "/getAttendanceSummary",
    getAdsStatus: NEW_PATH + "/adsStatus",                      //  广告状态

    
    // Hardware
    getAllGroupHardware: NEW_PATH + '/getAllGroupHardware',     //  获取个人设备信息
    allHardware: NEW_PATH + '/allHardware',                     //  获取所有设备信息
    dealHardware: NEW_PATH + '/dealHardware',                   //  设备修改
    deleteHardware:NEW_PATH + '/deleteHardware',                //  设备删除
    retrieveHardware:NEW_PATH + '/retrieveHardware',            //  重置设备

    // Tgif
    addQuestion:NEW_PATH + '/addQuestion',                      //  添加问题
    holdQuestion:NEW_PATH + '/holdQuestion',                    //  点赞问题
    getQuestion: NEW_PATH + '/getQuestion',                     //  问题列表
    dealQuestion: NEW_PATH + '/dealQuestion',                   //  处理问题
    getHistoryQuestion: NEW_PATH + '/getHistoryQuestion',       //  获取历史问题
    getMyselfQuestion: NEW_PATH + '/currentUserQuestion',       //  获取当前用户问题
    deleteQuestion: NEW_PATH + '/deleteQuestion',            //  删除问题

    addTopicQuestion:NEW_PATH + '/addTopicQuestion',            //  添加问题
    getCurrentTopic: NEW_PATH + '/getCurrentTopic',             //  获取当前专题列表
    holdTopic: NEW_PATH + '/holdTopic',                          //  对问题进行操作
    
    // Workday Management
    leaveManage: NEW_PATH + '/leaveManage',                     //  获取所有休假列表
    outManage: NEW_PATH + '/outManage',                         //  获取所有因公外出列表
    outDelete: NEW_PATH + '/outDelete',                         //  因公外出删除
    // Team Structure
    teamStructure: NEW_PATH + '/teamStructure',                 //  获取公司团队结构

    // 管理员权限获取
    getRole: NEW_PATH + '/getRole',                             //  通过id获取权限


    getAttendanceSummaryByYear:NEW_PATH + '/getAttendanceSummaryByYear',


    // 旧版发票报销
    addinvoice: PATH_API + '/addinvoice',
    getinvoice: PATH_API + '/getinvoice',
    seriallist: PATH_API + '/seriallist',
    invoice_type: PATH_API + '/invoice_type',
    addserial: PATH_API + '/addserial',
    del_invoice: PATH_API + '/del_invoice',
    apply_type: PATH_API + '/apply_type',

    // 招聘学校信息
    universityList: NEW_PATH + '/universityList',

    
  }
}

module.exports = api